import { render, staticRenderFns } from "./AddProjectPopup.vue?vue&type=template&id=665c4ab9&scoped=true&"
import script from "./AddProjectPopup.vue?vue&type=script&lang=js&"
export * from "./AddProjectPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectPopup.vue?vue&type=style&index=0&id=665c4ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c4ab9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VFlex,VForm,VIcon,VLayout,VSpacer,VToolbar,VToolbarTitle})
